import React, { useEffect, useRef } from 'react';

const SimpleCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const mousePos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    // Hide default cursor
    document.body.style.cursor = 'none';

    const updateMousePosition = (e) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
    };

    // Animation loop using requestAnimationFrame
    const animateCursor = () => {
      if (dotRef.current && ringRef.current) {
        dotRef.current.style.left = mousePos.current.x + 'px';
        dotRef.current.style.top = mousePos.current.y + 'px';
        ringRef.current.style.left = mousePos.current.x + 'px';
        ringRef.current.style.top = mousePos.current.y + 'px';
      }
      requestAnimationFrame(animateCursor);
    };

    // Start animation loop
    animateCursor();

    // Add event listener
    document.addEventListener('mousemove', updateMousePosition);

    // Cleanup
    return () => {
      document.body.style.cursor = 'auto';
      document.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);

  return (
    <>
      {/* Main cursor dot */}
      <div
        ref={dotRef}
        style={{
          position: 'fixed',
          width: '10px',
          height: '10px',
          backgroundColor: '#e6e6e6ff',
          borderRadius: '50%',
          pointerEvents: 'none',
          zIndex: 9999999,
          transform: 'translate(-50%, -50%)',
          mixBlendMode: 'difference'
        }}
      />
      
      {/* Cursor ring */}
      <div
        ref={ringRef}
        style={{
          position: 'fixed',
          width: '30px',
          height: '30px',
          border: '2px solid #e6e6e6ff',
          borderRadius: '50%',
          pointerEvents: 'none',
          zIndex: 9999998,
          transform: 'translate(-50%, -50%)',
          opacity: 0.6
        }}
      />
    </>
  );
};

export default SimpleCursor;